export default "__VITE_ASSET__BscO6HZc__"